import React from "react";
import { Field, Textarea } from "@fluentui/react-components";

const TextareaField = ({ name, label, value, error, onChange }) => (
  <Field label={label} validationState={error ? "error" : "none"} validationMessage={error}>
    <Textarea value={value} onChange={(e) => onChange(name, e.target.value)} />
  </Field>
);

export default TextareaField;